import { render, staticRenderFns } from "./solicitudVehiculosAprob.vue?vue&type=template&id=6b961bb7&scoped=true"
import script from "./solicitudVehiculosAprob.vue?vue&type=script&lang=js"
export * from "./solicitudVehiculosAprob.vue?vue&type=script&lang=js"
import style0 from "./solicitudVehiculosAprob.vue?vue&type=style&index=0&id=6b961bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b961bb7",
  null
  
)

export default component.exports